export default __webpack_public_path__ + "static/media/maintenance-icon.bad44a0f.svg";